(function (app) {

        app.directive("ngEnter", function () {

            return function (scope, element, attrs) {

                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        if (event.ctrlKey || event.which === 91) {
                            scope.$apply(function() {
                                scope.$eval(attrs.ngEnter);
                            });

                            event.preventDefault();
                        }
                    }
                });
            };
    });

})(window.app);